import React, { useState, useEffect } from "react";

import { Modal } from "antd";
import { toast } from "react-toastify";

import useAbortController from "../../../Common/hooks/useAbortController";
import StyledScrollbar from "../../../Common/UIComponents/StyledScrollbar";

import { formatDateForDisplay, formatStatusLabel } from "../../../../utils/helpers";

import { fetchSupplyRequestDetail } from "../../../../actions/supplyPickup";

import { ReactComponent as LoadingDots } from "../../../../assets/images/common/LoadingDots.svg";

import { designTokens } from "../../../../styles/tokens";
import "./ViewSupplyRequestModal.css";
import "../../Common/RequestTable.css";

const ViewSupplyRequestModal = ({ open: parentOpen, onClose, data: parentData }) => {
  const [data, setData] = useState({});
  const [landing, setLanding] = useState(true);
  const [modalClassName, setModalClassName] = useState("ViewSupplyRequestModal");
  const { setNewAbortController } = useAbortController();
  const requestTypeLabels = { recurring: "Recurring", normal: "Normal" };
  const generateInfo = [
    { param: "supply_order_id", label: "Order ID" },
    { param: "requested_by", label: "Requested by" },
    { param: "date", label: "Order Date" },
    { param: "status", label: "Status" },
    { param: "request_type", label: "Request Type" },
    { param: "comments", label: "Special Instructions" },
    { param: "response", label: "Genista Response" },
  ];
  const recurrenceHeader = [
    { param: "start_date", label: "Start Date" },
    { param: "end_date", label: "End Date" },
  ];

  const [open, setOpen] = useState(false);

  const handleCancel = (refresh = false) => {
    setOpen(false);
    onClose(refresh);
  };

  const fetchRequestDetail = async () => {
    setLanding(true);
    const newAbortController = setNewAbortController();
    const {
      success, result, message, canceled,
    } = await fetchSupplyRequestDetail(parentData.supply_order_id, newAbortController.signal);
    if (success) {
      setData(result);
      if (result?.dates?.length > 0) {
        setModalClassName("ViewSupplyRequestModal Recurrence");
      }
    } else if (!canceled) {
      setData({});
    } else {
      toast.error(message);
    }

    setLanding(canceled);
  };

  useEffect(() => {
    if (parentOpen) {
      setOpen(parentOpen);
      fetchRequestDetail();
    }
  }, [parentOpen, parentData]); // eslint-disable-line

  return (
    <Modal
      centered
      maskClosable
      destroyOnClose
      title="Supply Request"
      className={modalClassName}
      open={open}
      onCancel={() => handleCancel(false)}
      afterClose={() => setModalClassName("ViewSupplyRequestModal")}
      footer={null}
    >
      <div className="ViewSupplyRequestModal__ScrollContainer">
        <StyledScrollbar
          className="SupplyInventoryItemsScrollbar ViewSupplyRequestModal__Scrollbar"
          translateContentSizeYToHolder
        >
          {landing ? (
            <div className="ViewSupplyRequestModal__Loading">
              <LoadingDots width={30} height={30} fill={designTokens.colorBorderPrimary} />
            </div>
          ) : (
            <div className="ViewSupplyRequestModalBody">
              <div className="baseView">
                <div className="ViewSupplyRequestModal__Details">
                  {generateInfo.map((item) => {
                    const { param, label } = item;
                    let value = "-";

                    if (param === "date" && data[param]) {
                      value = formatDateForDisplay(data[param], "DD MMM YYYY");
                    } else if (param === "status" && data[param]) {
                      value = (
                        <span className={`RequestTableStatusCell--${data[param]}`}>
                          {formatStatusLabel(data[param])}
                        </span>
                      );
                    } else if (param === "request_type" && data[param]) {
                      value = requestTypeLabels[data[param]?.toLowerCase()] || "-";
                    } else if (data[param]) {
                      value = data[param];
                    }

                    return (
                      <p key={param}>
                        <strong>
                          {label}
                          :
                        </strong>
                        {" "}
                        {value}
                      </p>
                    );
                  })}
                </div>
                <div className="ViewSupplyRequestModal__Items">
                  <h6>Items Requested</h6>
                  <StyledScrollbar className="SupplyInventoryItemsScrollbar ViewRequestModal">
                    <div className="ViewSupplyRequestModal__ItemsList">
                      {data?.items?.map((item, index) => (
                        <div key={index} className="ViewSupplyRequestModal__Item">
                          <div className="image-container">
                            {item.image_url && <img src={item.image_url} alt={item.item_name} />}
                            {!item.image_url && <span>No Image</span>}
                          </div>
                          <div className="ViewSupplyRequestModal__ItemDetails">
                            <p>{item.item_name}</p>
                          </div>
                          <div className="ViewSupplyRequestModal__ItemQuantity">
                            <span>{item.quantity}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </StyledScrollbar>
                </div>
              </div>

              {data?.dates?.length > 0 && (
              <div className="ViewSupplyRequestModalBody__Recurrence" key="temp">
                <div className="ViewSupplyRequestModalBody__RecurrenceHeader">
                  {recurrenceHeader.map((item) => (
                    <div className="StartEndDateLabel" key={item.param}>
                      <label>{item.label}</label>
                      <span>{data[item.param] ? formatDateForDisplay(data[item.param], "DD MMM YYYY") : "-"}</span>
                    </div>
                  ))}
                </div>
                <div className="ViewSupplyRequestModal__Items RecurrentItems">
                  <h6>Upcoming supply request dates</h6>
                  <StyledScrollbar className="SupplyInventoryItemsScrollbar ViewRequestModal">
                    <div className="ViewSupplyRequestModal__ItemsList RecurrenceList">
                      {data.dates.map((date, dateIndex) => <span className="recurrenceDate" key={dateIndex}>{formatDateForDisplay(date, "DD MMM YYYY")}</span>)}
                    </div>
                  </StyledScrollbar>
                </div>
              </div>
              )}
            </div>
          )}
        </StyledScrollbar>
      </div>
    </Modal>
  );
};

export default ViewSupplyRequestModal;
